module.exports = __webpack_public_path__ + "static/media/bakri-postpartum-balloon-product@2x.50f3a87f.jpg";